<div class="table-responsive">
  <table class="table table-striped table-hover">
    <thead class="table-light">
      <tr>
        <th>Conversion ID</th>
        <th>Offer</th>
        <th>Date</th>
        <th>Revenue</th>
        <th>Tracker1</th>
        <th>Tracker2</th>
        <th>Tracker3</th>
        <th>Tracker4</th>
      </tr>
    </thead>
    <tbody>
      @for (statistic of statistics; track statistic) {
        <tr>
          <td>{{ statistic.id }}</td>
          <td>
            @if (statistic.offer) {
              <a [routerLink]="['/offer', statistic.offer.id]">
                {{ statistic.offer.name }}
              </a>
            }
          </td>
          <td>{{ statistic.getDate() | date: 'dd/MM/yyyy HH:mm' : getTimezone(statistic.date) }}</td>
          <td>{{ statistic.revenue | money:2:$safeNavigationMigration(statistic.currency?.isoCode) }}</td>
          <td>{{ statistic.tc1 }}</td>
          <td>{{ statistic.tc2 }}</td>
          <td>{{ statistic.tc3 }}</td>
          <td>{{ statistic.tc4 }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>

<app-paginator (pageChange)="fetchConversions()" [paginator]="paginator"></app-paginator>
